module.exports = __webpack_public_path__ + "static/media/ProximaNova-Semibold.f14eee64.otf";